module.exports = __webpack_public_path__ + "static/dg-4-05e681b254c153ba521479d71fcacae3.png";